import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import { Grid, _ } from 'gridjs-react';
import 'gridjs/dist/theme/mermaid.css'
import { gridOptions } from "../utils/gridOptions";
import { calculateAge, formatDate } from "../utils/utils";
import { useNavigate } from "react-router-dom";

const clasificacionMap = {
    0: '',
    1: 'Básico 1',
    2: 'Básico 2',
    3: 'Básico 3',
    4: 'D',
};

function Usuarios() {
    const navigate = useNavigate();
    // Estado para almacenar los valores de los filtros y la tabla de resultados
    const [fecha, setFecha] = useState("");
    const [resultados, setResultados] = useState([]);

    // Función para buscar los resultados con Axios
    useEffect(() => {
        const traeUsuarios = async () => {
            try {
                // Realiza la llamada a la API para obtener los auxiliares
                const response = await axiosInstance.get("/usuario/lista");

                setResultados(response.data.data); // Almacena los resultados en el estado
            } catch (error) {
                console.error("Error al buscar auxiliares: ", error);
            }
        };

        traeUsuarios();
    }, []);

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Usuarios</h3>
                    <div className="row g-3">
                        <div className="col-md-12 d-flex">
                            <button className="btn btn-primary" onClick={() => navigate('/usuarios/nuevo')}>
                                Crear Usuario
                            </button>
                        </div>
                    </div>
                    <div className="mt-3">
                        <Grid
                            data={resultados}
                            columns={[
                                { id: 'id', name: '', width: '25px' },
                                { id: 'nombre', name: 'Nombre', width: '200px' },
                                { id: 'apellido', name: 'Apellido', width: '200px' },
                                { id: 'correo_electronico', name: 'Correo electronico', width: '300px' },
                                { id: 'desc_perfil', name: 'Perfil', width: '200px' },
                                { id: 'telefono', name: 'Telefono', width: '150px' },
                                {
                                    id: 'id',
                                    name: 'Acción',
                                    formatter: (value, row, cell) =>
                                        _(
                                            row._cells[6].data === 1 ? null : (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => navigate('/usuarios/' + value)} // Captura el ID
                                                >
                                                    Editar
                                                </button>
                                            )
                                        ),
                                }
                            ]}
                            language={gridOptions.language}
                            search={gridOptions.search}
                            sort={gridOptions.sort}
                            pagination={gridOptions.pagination}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Usuarios;
